<template>
  <div id="Topcontent">
    <img class="image-layout" alt="Flowers" src="../assets/banner.jpg">
    <h1 style="margin-top:10px">The New Norms</h1>
    <h3 style="margin-top:-20px">Earn From Home</h3>
  </div>
</template>

<script>

export default {
  methods: {
    countdown () {
      const end = new Date('02/02/2022')
      const now = new Date()
      const distance = end.getTime() - now.getTime()
      return Math.floor(distance / 86400000)
    }
  }
}

</script>

<style lang="scss">
@import "../assets/common.scss";

.image-layout {
  margin-top:-15px;

  @media (max-width: 760px) {
    margin-top:0px;
    width: 80%
  }
}

</style>
